import { useTranslation } from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import MenuButtons from "components/MenuButtons";
import navsBridge from "./navsBridge";
import { useContext } from "react";
import AuthContext from "context/AuthContext";

const MainData = () => {
    const [t] = useTranslation("routes")
    const { panel } = useContext(AuthContext);
    const bread = [
        { name: t("labels.data-view"), current: true }
    ]

    return (
        <>
            {panel.panel_type === "w" ? (
                <NavBreadcrum navs={navs} bread={bread} />
            ) : (
                <NavBreadcrum navs={navsBridge} bread={bread} />
            )}
            <div className="row">
                <div className="col-12">
                </div>
            </div>
            <MenuButtons navs={navs} />
        </>
    )
}
export default MainData;